export const MessageComponent = ({ msg }) => {
  return <div className="messageComponent">{msg}</div>;
};
